// import React, { useContext, useState , useEffect } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import { AppContext } from '../context/AppContext';
// import '../css/mainhome.css';
// import '../css/AddFunds.css';

// import Header from '../components/Header';
// import BottomNav from '../components/BottomNav';
// import Sidebar from '../components/SideBar';
// import PaymentOptionsModal from '../components/PaymentOptionsModal'; // Import the new modal

// const AddFundsScreen = () => {
//   const navigate = useNavigate();
//   const { user ,refetchUser} = useContext(AppContext);
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const [amount, setAmount] = useState('');
//   // State to control the visibility of the payment modal
//   const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);

//    const [paymentStatus, setPaymentStatus] = useState('idle');
//    const settings = JSON.parse(localStorage.getItem('feeSettings') || '{}');


   


//   const minDeposit = settings?.minDeposit || 500;



//   //  useEffect(() => {
//   //   const pendingTx = localStorage.getItem('pendingTransaction');
//   //   if (pendingTx) {
//   //     verifyPayment(JSON.parse(pendingTx));
//   //   }
//   // }, []);

    
//     useEffect(() => {
//   // 1. Create a function to check for the transaction
//   const checkPendingTransaction = () => {
//     const pendingTx = localStorage.getItem('pendingTransaction');
//     if (pendingTx) {
//       verifyPayment(JSON.parse(pendingTx));
//     }
//   };

//   // 2. A handler that runs when tab visibility changes
//   const handleVisibilityChange = () => {
//     if (document.visibilityState === 'visible') {
//       checkPendingTransaction();
//     }
//   };

//   // 3. Check for the transaction when the page first loads
//   checkPendingTransaction();

//   // 4. Add the event listener to check again every time the user returns to the app
//   document.addEventListener('visibilitychange', handleVisibilityChange);

//   // 5. IMPORTANT: Clean up the listener when the component is removed
//   return () => {
//     document.removeEventListener('visibilitychange', handleVisibilityChange);
//   };
// }, []);




//   const verifyPayment = async (txDetails) => {
//     setPaymentStatus('pending');
//     localStorage.removeItem('pendingTransaction'); // Clear it so we don't check again

//     try {
//       const token = localStorage.getItem("accessToken");
//       // --- STEP 4: Make the confirmation API call ---
//       const response = await axios.post(
//         "https://admin.gama567.club/api/v1/add-upi-deposit-fund-request",
//         txDetails, // Send all the saved details
//         { headers: { "Authorization": `Bearer ${token}`,
//             "Content-Type": "application/json",
//             "deviceId": "qwert",
//             "deviceName": "sm2233",
//             "accessStatus": "1" } }
//       );
//   console.log(response);
//       if (response.data.status) {
//         setPaymentStatus('success');
//         await refetchUser(); // Refresh wallet balance
//       } else {
//         setPaymentStatus('failed');
//       }
//     } catch (error) {
//       console.error("Payment verification failed:", error);
//       setPaymentStatus('failed');
//     }
//   };







//   const handleAddFundClick = () => {
//     const numericAmount = parseInt(amount, 10);
//     if (!numericAmount || numericAmount < minDeposit) {
//       alert(`Please enter an amount of at least ₹${minDeposit}.`);
//       return;
//     }

//     console.log(`Proceeding to add ₹${numericAmount} `);
//     // Open the payment options modal instead of navigating
//     setIsPaymentModalOpen(true);
//   };


//   if (paymentStatus === 'pending' || paymentStatus === 'success' || paymentStatus === 'failed') {
//     return (
//       <div className="mainhome-screen-wrapper">
//         <div className="payment-status-overlay">
//           {paymentStatus === 'pending' && <h2>Verifying Payment...</h2>}
//           {paymentStatus === 'success' && <h2>Payment Successful!</h2>}
//           {paymentStatus === 'failed' && <h2>Payment Failed.</h2>}
//           <button className="funds-action-btn" onClick={() => setPaymentStatus('idle')}>
//             Close
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="mainhome-screen-wrapper">
//       <Header onMenuClick={() => setIsSidebarOpen(true)} />
//       <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
      
//       <div className="funds-container">
//         <div className="funds-content-top">
//           <div className="funds-balance-card">
//             <div className="funds-card-top">
//               <span className="funds-card-brand">SARA777</span>
//               <div className="funds-card-logo"></div>
//             </div>
//             <div className="funds-card-bottom">
//               <div className="funds-wallet-icon"></div>
//               <div>
//                 <span className="funds-balance-amount">₹{user?.walletBalance || 0}</span>
//                 <span className="funds-balance-label">Current Balance</span>
//               </div>
//             </div>
//           </div>
          

//           {/* Add Fund Input Field */}
//           <div className="funds-input-wrapper">
//             <div className="funds-bank-icon"></div>
//             <input 
//               type="tel"
//               className="funds-input"
//               placeholder={`Add Fund (Min ₹${minDeposit})`}
//               value={amount}
//               onChange={(e) => setAmount(e.target.value.replace(/[^0-9]/g, ''))}
//             />
//           </div>
//         </div>

//         {/* Action Buttons now trigger the modal */}
//         <div className="funds-action-buttons">
//           <button className="funds-action-btn" onClick={handleAddFundClick}>ADD POINT - UPI</button>
//           <button className="funds-action-btn" onClick={handleAddFundClick}>ADD POINT - QR - PAYTM - GATEWAY</button>
//           <button className="funds-action-btn">HOW TO ADD POINT</button>
//         </div>
//       </div>
      
//       <BottomNav active="Funds" />

//       {/* Render the modal when it's open */}
//       {isPaymentModalOpen && (
//         <PaymentOptionsModal 
//           amount={parseInt(amount, 10)} 
//           onClose={() => setIsPaymentModalOpen(false)} 
//         />
//       )}
//     </div>
//   );
// };

// export default AddFundsScreen;







import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { AppContext } from '../context/AppContext';
import '../css/mainhome.css';
import '../css/AddFunds.css';
import { useLocation, useNavigate } from 'react-router-dom';
import AppHeader from '../components/AppHeader';
import PaymentOptionsModal from '../components/PaymentOptionsModal';
import addFundsQrImage from '../assets/images/QR.jpeg';
import whatsappIcon from '../assets/icons/logos_whatsapp-icon.svg';
import googlePayIcon from '../assets/icons/google-pay-or-tez-logo-svgrepo-com.svg';
import phonePeIcon from '../assets/icons/phonepe-icon.svg';
import paytmIcon from '../assets/icons/paytm_icon-icons.com_62778.svg';

/** When flag is missing, treat as enabled so older API payloads still work */
function isDepositMethodEnabled(value) {
  if (value === undefined || value === null || value === '') return true;
  if (value === false || value === 'false' || value === 0 || value === '0') return false;
  return Boolean(value);
}

function isInactiveAccountStatus(accountStatus) {
  if (accountStatus === false || accountStatus === 0) return true;
  if (typeof accountStatus !== 'string') return false;
  const normalized = accountStatus.trim().toLowerCase();
  return normalized === 'false' || normalized === '0' || normalized === 'inactive';
}

function isActiveAccountStatus(accountStatus) {
  if (accountStatus === true || accountStatus === 1) return true;
  if (typeof accountStatus !== 'string') return false;
  const normalized = accountStatus.trim().toLowerCase();
  return normalized === 'true' || normalized === '1' || normalized === 'active';
}

function readStoredInactiveStatus() {
  try {
    if (localStorage.getItem('inactiveWalletBalance') !== null) return true;
    const raw = localStorage.getItem('userProfile');
    if (!raw) return false;
    const storedUser = JSON.parse(raw);
    return [
      storedUser?.accountStatus,
      storedUser?.account_status,
      storedUser?.status,
      storedUser?.isActive,
      storedUser?.active,
    ].some(isInactiveAccountStatus);
  } catch {
    return false;
  }
}

function readFeeSettingsFromStorage() {
  try {
    const raw = localStorage.getItem('feeSettings');
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

/** UPI ID for display/copy — backend may use different keys on fees-settings `info` */
function extractUpiIdFromSettings(settings) {
  if (!settings || typeof settings !== 'object') return '';
  const keys = [
    'upiId',
    'upiID',
    'UPIID',
    'upi_id',
    'merchantUpi',
    'merchantUPI',
    'depositUpi',
    'staticUpi',
    'staticUPI',
    'payUpiId',
    'deposit_upi',
  ];
  for (const k of keys) {
    const v = settings[k];
    if (typeof v === 'string' && v.trim()) return v.trim();
  }
  return '';
}

function stripPhoneDigits(raw) {
  return String(raw ?? '').replace(/\D/g, '');
}

function buildTelHref(digits) {
  if (!digits) return undefined;
  if (digits.length === 10) return `tel:+91${digits}`;
  return `tel:+${digits}`;
}

function buildWaUrl(digits) {
  if (!digits) return undefined;
  return `https://wa.me/${digits}`;
}

const FALLBACK_UPI_ID = 'BHARATPE.8S0P0N9A3M25053@fbpe';
const FALLBACK_WHATSAPP_DIGITS = '917737091311';

const PRESET_AMOUNTS = [500, 1000, 1500, 2000, 5000, 10000];

const INACTIVE_PAYMENT_METHODS = [
  { id: 'phonePe', label: 'PhonePe', icon: phonePeIcon, type: 'image' },
  { id: 'googlePay', label: 'Google Pay', icon: googlePayIcon, type: 'image' },
  { id: 'paytm', label: 'Paytm', icon: paytmIcon, type: 'image' },
  { id: 'upi', label: 'Other UPI Gateway', apiDepositType: 'googlePay', type: 'upi' },
];

const AddFundsScreen = () => {
  const { user, refetchUser, isInactive } = useContext(AppContext);
  const navigate = useNavigate();
  const location = useLocation();
  const qrImagePath = addFundsQrImage;
  const simpleAddFundMode = new URLSearchParams(location.search).get('simple') === '1';
  const userStatusValues = [
    user?.accountStatus,
    user?.account_status,
    user?.status,
    user?.isActive,
    user?.active,
  ];
  const isKnownActiveUser = userStatusValues.some(isActiveAccountStatus);
  const isKnownInactiveUser =
    isInactive === true ||
    userStatusValues.some(isInactiveAccountStatus);
  const isInactiveUser =
    !isKnownActiveUser &&
    (simpleAddFundMode ||
      location.state?.inactiveAddFund === true ||
      isKnownInactiveUser ||
      readStoredInactiveStatus());

  const [feeSettings, setFeeSettings] = useState(readFeeSettingsFromStorage);
  const [whatsappRaw, setWhatsappRaw] = useState(null);
  const [amount, setAmount] = useState('');
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [selectedInactiveMethod, setSelectedInactiveMethod] = useState('phonePe');
  const [paymentStatus, setPaymentStatus] = useState('idle');
  const wasHiddenRef = useRef(false);

  const showUpi = useMemo(() => isDepositMethodEnabled(feeSettings.upiStatus), [feeSettings]);
  const showQr = useMemo(() => isDepositMethodEnabled(feeSettings.qrStatus), [feeSettings]);
  const minDeposit = Number(feeSettings.minDeposit) > 0 ? Number(feeSettings.minDeposit) : 500;
  const upiIdDisplay = extractUpiIdFromSettings(feeSettings) || FALLBACK_UPI_ID;

  const whatsappDigits = useMemo(() => {
    const fromApi = stripPhoneDigits(whatsappRaw);
    return fromApi || FALLBACK_WHATSAPP_DIGITS;
  }, [whatsappRaw]);

  const whatsappDisplay = useMemo(() => {
    if (whatsappRaw && String(whatsappRaw).trim()) return String(whatsappRaw).trim();
    return '+91 77370 91311';
  }, [whatsappRaw]);

  const waUrl = buildWaUrl(whatsappDigits);
  const telHref = buildTelHref(whatsappDigits);

  useEffect(() => {
    const fetchFees = async () => {
      try {
        const token = localStorage.getItem('accessToken');
        const mobileNo = localStorage.getItem('mobileNo');
        const response = await axios.get(`https://admin.gama567app.net/api/v1/fees-settings`, {
          data: { mobileNo },
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            deviceId: 'qwert',
            deviceName: 'sm2233',
            accessStatus: '1',
          },
        });
        const { status, info } = response.data || {};
        if (status === true && info && typeof info === 'object') {
          localStorage.setItem('feeSettings', JSON.stringify(info));
          setFeeSettings(info);
        }
      } catch (err) {
        console.error('AddFunds: fees-settings fetch failed', err);
        setFeeSettings(readFeeSettingsFromStorage());
      }
    };
    fetchFees();
  }, []);

  useEffect(() => {
    const fetchContact = async () => {
      try {
        const token = localStorage.getItem('accessToken');
        const response = await axios.get('https://admin.gama567app.net/api/v1/contact-detail', {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            deviceId: 'qwert',
            deviceName: 'sm2233',
            accessStatus: '1',
          },
        });
        const wa = response.data?.info?.contactInfo?.whatsappNo;
        if (wa != null && String(wa).trim()) setWhatsappRaw(String(wa).trim());
      } catch (err) {
        console.error('AddFunds: contact-detail fetch failed', err);
      }
    };
    fetchContact();
  }, []);

  const verifyPayment = useCallback(
    async (txDetails) => {
      setPaymentStatus('pending');
      try {
        const token = localStorage.getItem('accessToken');
        if (!token) throw new Error('Missing token');
        const res = await axios.post(
          'https://admin.gama567app.net/api/v1/add-upi-deposit-fund-request',
          txDetails,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
              deviceId: 'qwert',
              deviceName: 'sm2233',
              accessStatus: '1',
            },
          }
        );
        if (res?.data?.status) {
          setPaymentStatus('success');
          await refetchUser?.();
          localStorage.removeItem('pendingTransaction');
        } else {
          setPaymentStatus('failed');
        }
      } catch (e) {
        console.error('Payment verification failed:', e);
        setPaymentStatus('failed');
      }
    },
    [refetchUser]
  );

  useEffect(() => {
    const onVisibility = () => {
      if (document.visibilityState === 'hidden') {
        wasHiddenRef.current = true;
      } else if (document.visibilityState === 'visible') {
        if (wasHiddenRef.current) {
          const pending = localStorage.getItem('pendingTransaction');
          if (pending) {
            try {
              const tx = JSON.parse(pending);
              if (!tx.createdAt || Date.now() - tx.createdAt > 1200) {
                verifyPayment(tx);
              }
            } catch {
              /* ignore */
            }
          }
          wasHiddenRef.current = false;
        }
      }
    };

    const onFocusLikeReturn = () => {
      if (wasHiddenRef.current) {
        const pending = localStorage.getItem('pendingTransaction');
        if (pending) {
          try {
            const tx = JSON.parse(pending);
            if (!tx.createdAt || Date.now() - tx.createdAt > 1200) {
              verifyPayment(tx);
            }
          } catch {
            /* ignore */
          }
        }
        wasHiddenRef.current = false;
      }
    };

    document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('focus', onFocusLikeReturn);
    window.addEventListener('pageshow', onFocusLikeReturn);
    return () => {
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('focus', onFocusLikeReturn);
      window.removeEventListener('pageshow', onFocusLikeReturn);
    };
  }, [verifyPayment]);

  const copyUpiId = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(upiIdDisplay);
      toast.success('UPI ID copied');
    } catch {
      try {
        const ta = document.createElement('textarea');
        ta.value = upiIdDisplay;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        toast.success('UPI ID copied');
      } catch {
        toast.error('Could not copy. Please copy manually.');
      }
    }
  }, [upiIdDisplay]);

  const handleAddFundClick = () => {
    const numericAmount = Number(amount);
    if (!Number.isFinite(numericAmount) || numericAmount < minDeposit) {
      toast.error(`Please enter an amount of at least ₹${minDeposit}.`);
      return;
    }
    setIsPaymentModalOpen(true);
  };

  const handleInactiveSendRequest = () => {
    const numericAmount = Number(amount);
    if (!Number.isFinite(numericAmount) || numericAmount < minDeposit) {
      toast.error(`Please enter points of at least ₹${minDeposit}.`);
      return;
    }

    setIsPaymentModalOpen(true);
  };

  const openWhatsApp = useCallback(() => {
    if (!waUrl) return;
    window.open(waUrl, '_blank', 'noopener,noreferrer');
  }, [waUrl]);

  /** Bundled image URLs often ignore `<a download>`; fetch blob so save works on mobile/desktop */
  const handleDownloadQr = useCallback(async () => {
    try {
      const res = await fetch(qrImagePath);
      if (!res.ok) throw new Error('fetch failed');
      const blob = await res.blob();
      const ext = blob.type.includes('png') ? 'png' : 'jpg';
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `gama567-add-funds-qr.${ext}`;
      a.rel = 'noopener';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      toast.success('Download started');
    } catch (e) {
      console.error('QR download failed:', e);
      try {
        window.open(qrImagePath, '_blank', 'noopener,noreferrer');
        toast.info('Opened image — use your browser menu to save');
      } catch {
        toast.error('Could not download QR. Long-press the image to save.');
      }
    }
  }, [qrImagePath]);

  const topTitle = useMemo(() => {
    if (showUpi && showQr) return 'UPI or QR — add funds';
    if (showUpi) return 'Add funds via UPI';
    if (showQr) return 'Scan QR to add funds';
    return 'Add funds';
  }, [showUpi, showQr]);

  if (paymentStatus !== 'idle') {
    return (
      <div className="mainhome-screen-wrapper">
        <div className="payment-status-overlay add-funds-payment-overlay">
          {paymentStatus === 'pending' && <h2>Verifying Payment...</h2>}
          {paymentStatus === 'success' && <h2>Payment Successful!</h2>}
          {paymentStatus === 'failed' && <h2>Payment Failed.</h2>}
          <button type="button" className="add-funds-overlay-close" onClick={() => setPaymentStatus('idle')}>
            Close
          </button>
        </div>
      </div>
    );
  }

  const showUpiIdBlock = Boolean(upiIdDisplay) && (showQr || showUpi);
  const methodsAvailable = showUpi || showQr;
  const isUpiOnly = showUpi && !showQr;

  if (isInactiveUser) {
    return (
      <div className="mainhome-screen-wrapper inactive-add-funds-screen">
        <div className="inactive-add-funds-title">
          <button type="button" className="inactive-add-funds-title-back" onClick={() => navigate(-1)} aria-label="Back">
            ‹
          </button>
          <span>Add Fund</span>
        </div>

        <div className="inactive-add-funds-body">
          <div className="inactive-add-funds-hero" aria-hidden="true">
            <div className="inactive-add-funds-blob"></div>
            <div className="inactive-add-funds-card-art">
              <span></span>
              <i></i>
            </div>
            <div className="inactive-add-funds-plant"></div>
            <div className="inactive-add-funds-person">
              <span></span>
              <i></i>
            </div>
          </div>

          <section className="inactive-add-funds-balance" aria-label="Total wallet balance">
            <div className="inactive-add-funds-rupee">₹</div>
            <div>
              <p>Total Wallet Balance</p>
              <strong>₹{user?.walletBalance ?? 0}</strong>
            </div>
          </section>

          <section className="inactive-add-funds-panel" aria-label="Add points">
            <div className="inactive-add-funds-input-wrap">
              <input
                inputMode="decimal"
                pattern="[0-9]*"
                placeholder="Enter points"
                value={amount}
                onChange={(e) => {
                  const v = e.target.value.replace(/[^0-9.]/g, '');
                  const safe = v.replace(/^(\d*\.?\d{0,2}).*$/, '$1');
                  setAmount(safe);
                }}
              />
              <span>₹</span>
            </div>
          </section>

          <div className="inactive-add-funds-methods" role="radiogroup" aria-label="Payment method">
            {INACTIVE_PAYMENT_METHODS.map((method) => (
              <button
                key={method.id}
                type="button"
                className="inactive-add-funds-method"
                onClick={() => setSelectedInactiveMethod(method.id)}
                role="radio"
                aria-checked={selectedInactiveMethod === method.id}
              >
                {method.type === 'image' ? (
                  <img src={method.icon} alt="" />
                ) : (
                  <span className="inactive-add-funds-upi-icon">°</span>
                )}
                <span className="inactive-add-funds-method-label">{method.label}</span>
                <span className="inactive-add-funds-radio" aria-hidden="true"></span>
              </button>
            ))}
          </div>

          <button type="button" className="inactive-add-funds-send" onClick={handleInactiveSendRequest}>
            SEND REQUEST
          </button>
        </div>

        {isPaymentModalOpen && (
          <PaymentOptionsModal
            amount={Number(amount)}
            onClose={() => setIsPaymentModalOpen(false)}
          />
        )}
      </div>
    );
  }

  return (
    <div className="mainhome-screen-wrapper">
      <AppHeader
        title="ADD FUNDS"
        walletBalance={user?.walletBalance}
        onBack={() => navigate(-1)}
        onWalletClick={() => navigate('/passbook')}
      />
      <div className="funds-container add-funds-page">
        {!isUpiOnly && (
          <div className="add-funds-top-bar">
            <span className="add-funds-top-title">{topTitle}</span>
            <span className="add-funds-top-balance">Balance ₹{user?.walletBalance ?? 0}</span>
          </div>
        )}

        {isUpiOnly && (
          <div className="funds-content-top">
            <div className="funds-balance-card">
              <div className="funds-card-top">
                <span className="funds-card-brand">Gama567</span>
                <div className="funds-card-logo"></div>
              </div>
              <div className="funds-card-bottom">
                <div className="funds-wallet-icon"></div>
                <div>
                  <span className="funds-balance-amount">₹{user?.walletBalance || 0}</span>
                  <span className="funds-balance-label">Current Balance</span>
                </div>
              </div>
            </div>

            <div className="funds-input-wrapper">
              <div className="funds-bank-icon"></div>
              <input
                inputMode="decimal"
                pattern="[0-9]*"
                className="funds-input"
                placeholder={`Add Fund (Min ₹${minDeposit})`}
                value={amount}
                onChange={(e) => {
                  const v = e.target.value.replace(/[^0-9.]/g, '');
                  const safe = v.replace(/^(\d*\.?\d{0,2}).*$/, '$1');
                  setAmount(safe);
                }}
              />
            </div>

            <div className="funds-preset-buttons">
              {PRESET_AMOUNTS.map((p) => (
                <button
                  key={p}
                  type="button"
                  className="funds-preset-btn"
                  onClick={() => setAmount(String(p))}
                >
                  ₹{p.toLocaleString('en-IN')}
                </button>
              ))}
            </div>

            <button type="button" className="funds-action-btn" onClick={handleAddFundClick}>
              ADD POINTS - UPI
            </button>
          </div>
        )}

        {!isUpiOnly && <div className="add-funds-sheet">
          {!methodsAvailable && (
            <div className="add-funds-methods-off" role="status">
              Deposit options are temporarily unavailable. Please contact us on WhatsApp for help.
            </div>
          )}

          {showUpi && (
            <>
              <section className="add-funds-upi-flow" aria-label="UPI deposit amount">
                <div className="funds-input-wrapper">
                  <div className="funds-bank-icon"></div>
                  <input
                    inputMode="decimal"
                    pattern="[0-9]*"
                    className="funds-input"
                    placeholder={`Add Fund (Min ₹${minDeposit})`}
                    value={amount}
                    onChange={(e) => {
                      const v = e.target.value.replace(/[^0-9.]/g, '');
                      const safe = v.replace(/^(\d*\.?\d{0,2}).*$/, '$1');
                      setAmount(safe);
                    }}
                  />
                </div>
                <div className="funds-preset-buttons">
                  {PRESET_AMOUNTS.map((p) => (
                    <button
                      key={p}
                      type="button"
                      className="funds-preset-btn"
                      onClick={() => setAmount(String(p))}
                    >
                      ₹{p.toLocaleString('en-IN')}
                    </button>
                  ))}
                </div>
                <button type="button" className="funds-action-btn" onClick={handleAddFundClick}>
                  ADD POINTS - UPI
                </button>
              </section>
              <hr className="add-funds-divider" />
            </>
          )}

          <section className="add-funds-sheet-section" aria-label="Support contact">
            <p className="add-funds-sheet-label">For add funds related query — call or WhatsApp</p>
            <div className="add-funds-contact-row">
              {telHref ? (
                <a className="add-funds-phone-link" href={telHref}>
                  {whatsappDisplay}
                </a>
              ) : (
                <span className="add-funds-phone-link">{whatsappDisplay}</span>
              )}
              {waUrl && (
                <button
                  type="button"
                  className="add-funds-wa-btn"
                  onClick={openWhatsApp}
                  aria-label="Open WhatsApp chat"
                >
                  <img src={whatsappIcon} alt="" width={28} height={28} />
                </button>
              )}
            </div>
          </section>

          {showUpiIdBlock && (
            <>
              <hr className="add-funds-divider" />
              <section className="add-funds-sheet-section" aria-label="UPI ID">
                <p className="add-funds-sheet-label">UPI ID</p>
                <div className="add-funds-upi-row">
                  <span className="add-funds-upi-text">{upiIdDisplay}</span>
                  <button type="button" className="add-funds-copy-btn" onClick={copyUpiId} aria-label="Copy UPI ID">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                      <path
                        d="M8 4v12a2 2 0 002 2h8a2 2 0 002-2V7.242a2 2 0 00-.602-1.43L16.192 3.36A2 2 0 0014.59 2H10a2 2 0 00-2 2v0z"
                        stroke="currentColor"
                        strokeWidth="1.75"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M16 18v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-8a2 2 0 012-2h2"
                        stroke="currentColor"
                        strokeWidth="1.75"
                        strokeLinecap="round"
                      />
                    </svg>
                  </button>
                </div>
              </section>
            </>
          )}

          {showQr && (
            <>
              <hr className="add-funds-divider" />
              <section className="add-funds-sheet-section add-funds-qr-inline-section" aria-label="Payment QR">
                <div className="add-funds-qr-inline">
                  <div className="add-funds-qr-frame add-funds-qr-frame--compact">
                    <img
                      src={qrImagePath}
                      alt="Payment QR code"
                      className="add-funds-qr-image"
                      loading="lazy"
                    />
                  </div>
                  <div className="add-funds-qr-inline-actions">
                    <span className="add-funds-qr-hint">Scan or save</span>
                    <button
                      type="button"
                      className="add-funds-download-btn add-funds-download-btn--compact"
                      onClick={handleDownloadQr}
                    >
                      Download QR
                    </button>
                  </div>
                </div>
              </section>
            </>
          )}

          {(showQr || showUpi || !methodsAvailable) && <hr className="add-funds-divider" />}

          <section className="add-funds-instructions" aria-label="Deposit instructions">
            {!methodsAvailable && (
              <p className="add-funds-instruction-p">
                When deposits reopen, you can use UPI or QR from this screen. For now, use WhatsApp above.
              </p>
            )}
            {showQr && (
              <>
                <p className="add-funds-instruction-p">
                  <strong>English:</strong> Deposit by scanning the QR code. After payment, send the payment screenshot
                  and your <strong>registered mobile number</strong> on WhatsApp. Minimum deposit{' '}
                  <strong>₹{minDeposit}</strong>.
                </p>
                <p className="add-funds-instruction-p add-funds-instruction-p--hinglish">
                  <strong>Hindi:</strong> QR code scan karke payment karein, phir payment ka screenshot aur{' '}
                  <strong>registered</strong> mobile number WhatsApp par bhejein.
                </p>
                <p className="add-funds-instruction-p add-funds-instruction-p--hi" lang="hi">
                  डिपॉजिट QR कोड स्कैन करके करें और पेमेंट स्क्रीनशॉट तथा रजिस्टर मोबाइल नंबर व्हाट्सएप पर भेजें। न्यूनतम
                  डिपॉजिट ₹{minDeposit}।
                </p>
                <p className="add-funds-instruction-p add-funds-instruction-p--te" lang="te">
                  డిపాజిట్ QR కోడ్ ను స్కాన్ చేయండి మరియు చెల్లింపు స్క్రీన్ షాట్ మరియు రిజిస్టర్డ్ మొబైల్ నంబర్ ను వాట్సాప్ లో
                  పంపండి. కనీస డిపాజిట్ ₹{minDeposit}.
                </p>
              </>
            )}
            {showUpi && !showQr && (
              <p className="add-funds-instruction-p">
                <strong>English:</strong> Choose an amount, tap <strong>ADD POINTS — UPI</strong>, complete payment in
                your app, then send the payment screenshot and your <strong>registered mobile number</strong> on WhatsApp
                if required. Minimum deposit <strong>₹{minDeposit}</strong>.
              </p>
            )}
            {showUpi && showQr && (
              <p className="add-funds-instruction-p">
                <strong>UPI apps:</strong> Enter amount and use <strong>ADD POINTS — UPI</strong> to pay via Google Pay,
                PhonePe, or Paytm.
              </p>
            )}
          </section>
        </div>}
      </div>

      {isPaymentModalOpen && (
        <PaymentOptionsModal amount={Number(amount)} onClose={() => setIsPaymentModalOpen(false)} />
      )}
    </div>
  );
};

export default AddFundsScreen;
